const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.INFLUENCERS_ANALYTICS)

export const apiInfluencersAnalisys = {
	fetchInfluencersAnalisys: async (
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IDiscountInfluencerAnalisysModel[]>> => {
		const { data, meta } = await apiCommon<IDiscountInfluencerAnalisys[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})

		return { data: data.map(DiscountInfluencerAnalisys), meta }
	},
	fetchInfluencerAnalisysForCoupon: async (id: number): Promise<IDiscountInfluencerAnalisysDetailsModel> => {
		const { data } = await apiCommon<IDiscountInfluencerAnalisysDetails>(`${groupPrefix}/${id}`, { method: 'GET' })

		return DiscountInfluencerAnalisysDetails(data)
	},
}
